import { render, staticRenderFns } from "./EditemailActivate.vue?vue&type=template&id=d895c6e0&"
import script from "./EditemailActivate.vue?vue&type=script&lang=js&"
export * from "./EditemailActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports